// extracted by mini-css-extract-plugin
module.exports = {"table":"Faq_table__ZIP89"};